// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Customers',
  subtitle: 'Manage all customer information',
  addNew: 'Add New Customer',
  editCustomer: 'Edit Customer',
  searchPlaceholder: 'Search customers...',
  filterAll: 'All',
  filterActive: 'Active Customers',
  filterInactive: 'Inactive Customers',
  resultsFound: 'customers found',
  noCustomers: 'No customers yet',
  noCustomersFiltered: 'No customers found matching search or filter criteria',
  name: 'Full Name',
  email: 'E-mail',
  phone: 'Phone',
  address: 'Address',
  notes: 'Notes',
  password: 'Password',
  companies: 'Companies',
  companiesMultiple: 'Companies (You can select multiple)',
  noCompanies: 'No companies yet',
  companiesSelected: 'companies selected',
  newCompany: 'Add New Company',
  passwordChange: 'Enter new password to change',
  passwordRequired: 'Customer login password',
  passwordHint: 'Leave blank if you don\'t want to change the password',
  saving: 'Saving...',
  saveButton: 'Add',
  updateButton: 'Update',
  cancelButton: 'Cancel',
  selectedCount: 'customers selected',
  activateSelected: 'Activate',
  deactivateSelected: 'Deactivate',
  deleteSelected: 'Delete Selected Customers',
  tableCustomer: 'Customer',
  tableContact: 'Contact',
  tableCompany: 'Company',
  tableAddress: 'Address',
  tableStatus: 'Status',
  tableActions: 'Actions',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  activate: 'Activate',
  deactivate: 'Deactivate',
  view: 'View',
  edit: 'Edit',
  resetPassword: 'Reset Password',
  delete: 'Delete',
  customerDetails: 'Customer Details',
  detailName: 'Full Name',
  detailEmail: 'E-mail',
  detailPhone: 'Phone',
  detailCompanies: 'Companies',
  detailAddress: 'Address',
  detailNotes: 'Notes',
  detailRegDate: 'Registration Date',
  close: 'Close',
  newCompanyTitle: 'Add New Company',
  companyName: 'Company Name',
  companyPhone: 'Phone',
  companyEmail: 'E-mail',
  companyWebsite: 'Website',
  companyTaxNumber: 'Tax Number',
  companyAddress: 'Address',
  companyDescription: 'Description',
  companyAddButton: 'Add Company',
  resetPasswordTitle: 'Reset Password',
  resetPasswordDesc: 'Set a new password for the customer.',
  newPassword: 'New Password',
  newPasswordPlaceholder: 'At least 6 characters',
  newPasswordHint: 'Password must be at least 6 characters',
  sendEmail: 'Send password via e-mail',
  resetButton: 'Reset Password',
  errorFetch: 'Customers could not be fetched',
  errorFetchCompanies: 'Companies could not be fetched',
  errorPasswordRequired: 'Password is required for new customer',
  errorOperation: 'Operation failed',
  errorCompanyAdd: 'Company could not be added',
  errorDelete: 'Customer could not be deleted',
  errorSelectToDelete: 'Please select at least one customer to delete',
  errorSession: 'You need to log in.',
  errorSessionExpired: 'Your session has expired.',
  errorConnection: 'Connection error occurred',
  errorPasswordMinLength: 'Password must be at least 6 characters',
  errorSelectToUpdate: 'Please select at least one customer to update',
  confirmDelete: 'Are you sure you want to delete this customer?',
  confirmDeleteMultiple: 'Do you want to delete {{count}} customers?',
  confirmActivateMultiple: 'Do you want to activate {{count}} customers?',
  confirmDeactivateMultiple: 'Do you want to deactivate {{count}} customers?',
  successDeleted: '{{count}} customers successfully deleted',
  successUpdated: '{{count}} customers successfully updated',
  successExport: 'Customers successfully exported',
  successPasswordReset: 'Password successfully reset',
  exportFileName: 'customers_',
  exportSheetName: 'Customers',
  exportColumns: {
    name: 'Customer Name',
    email: 'E-mail',
    phone: 'Phone',
    address: 'Address',
    companies: 'Companies',
    status: 'Status',
    createdAt: 'Created At'
  }
};
